declare global {
  interface RouterMeta {
    title: string;
  }
  interface Router {
    path: string;
    name?: string;
    icon?: string;
    permission?: string;
    meta?: RouterMeta;
    component: any;
    children?: Array<Router>;
    props?: any;
  }
  interface System {
    import(request: string): Promise<any>;
  }
  var System: System;
}
import login from "../views/login.vue";
import home from "../views/home/home.vue";
import main from "../views/main.vue";
import front from "../views/front.vue";

export const locking = {
  path: "/locking",
  name: "locking",
  component: () =>
    import("../components/lockscreen/components/locking-page.vue"),
};
export const loginRouter: Router = {
  path: "/",
  name: "login",
  meta: {
    title: "LogIn",
  },
  component: () => import("../views/login.vue"),
};
export const registerRouter: Router = {
  path: "/register",
  name: "register",
  meta: {
    title: "Register",
  },
  component: () => import("../views/register.vue"),
};
export const forgetRouter: Router = {
  path: "/forget",
  name: "forget",
  meta: {
    title: "ForgetPassword",
  },
  component: () => import("../views/forget.vue"),
};
// export const frontRouter: Router = {
//     path: "/",
//     meta: { title: "Front" },
//     component: front,
//     children: [
//         {
//             path: "/",
//             meta: { title: "HomePage" },
//             name: "fronthome",
//             component: () => import("../views/front/home.vue")
//         },
//         {
//             path: "articles",
//             meta: { title: "GolfNews" },
//             name: "frontArticles",
//             component: () => import("../views/front/articles.vue")
//         },
//         {
//             path: "article-detail/:id",
//             meta: { title: "ArticleDetail" },
//             name: "frontArticleDetail",
//             component: () => import("../views/front/article-detail.vue"),
//             props: true
//         },
//         {
//             path: "topic-detail/:id",
//             meta: { title: "TopicDetail" },
//             name: "frontTopicDetail",
//             component: () => import("../views/front/topic-detail.vue"),
//             props: true
//         },
//         {
//             path: "travels",
//             meta: { title: "TravelAndGolf" },
//             name: "frontTravels",
//             component: () => import("../views/front/travel.vue")
//         },
//         {
//             path: "travel-detail/:id",
//             meta: { title: "TravelAndGolfDetail" },
//             name: "frontTravelDetail",
//             component: () => import("../views/front/travel-detail.vue")
//         },
//         {
//             path: "courts",
//             meta: { title: "CourtsAll" },
//             name: "frontCourts",
//             component: () => import("../views/front/courts.vue")
//         },
//         {
//             path: "court-detail/:id/:date?",
//             meta: { title: "CourtDetail" },
//             name: "frontCourtDetail",
//             component: () => import("../views/front/court-detail.vue")
//         },
//         {
//             path: "recruit",
//             meta: { title: "Recruits" },
//             name: "frontRecruit",
//             component: () => import("../views/front/recruits.vue")
//         },
//         {
//             path: "recruit-detail/:id",
//             meta: { title: "RecruitDetail" },
//             name: "frontRecruitDetail",
//             component: () => import("../views/front/recruit-detail.vue")
//         },
//         {
//             path: "search",
//             meta: { title: "SearchCourt" },
//             name: "search",
//             component: () => import("../views/front/search.vue")
//         },
//         {
//             path: "search-map",
//             meta: { title: "SearchOnMap" },
//             name: "searchOnMap",
//             component: () => import("../views/front/search-map.vue")
//         },
//         {
//             path: "my-orders",
//             meta: { title: "MyOrders" },
//             name: "myOrders",
//             component: () => import("../views/front/my-orders.vue")
//         },
//         {
//             path: "frontTicket",
//             meta: { title: "套票会籍" },
//             name: "frontTicket",
//             component: () => import("../views/front/ticket.vue")
//         },
//         {
//             path: "ticketDetail",
//             meta: { title: "套票会籍详情" },
//             name: "frontTicketDetail",
//             component: () => import("../views/front/ticket-detail.vue")
//         },
//         {
//             path: "alipay-return",
//             meta: { title: "AlipayReturn" },
//             name: "alipayReturn",
//             component: () => import("../views/front/alipay-return.vue")
//         },
//         {
//             path: "preferentials",
//             meta: { title: "PreferentialCourt" },
//             name: "frontPreferentials",
//             component: () => import("../views/front/preferential.vue")
//         },
//         {
//             path: "secondhands",
//             meta: { title: "SecondHand" },
//             name: "frontSecondHands",
//             component: () => import("../views/front/secondhand.vue")
//         },
//         {
//             path: "secondhand-detail/:id",
//             meta: { title: "SecondHandDetail" },
//             name: "frontSecondHandDetail",
//             component: () => import("../views/front/secondhand-detail.vue"),
//             props: true
//         }
//     ]
// }; //name: 'front',
export const otherRouters: Router = {
  path: "/main",
  name: "main",
  permission: "",
  meta: { title: "ManageMenu" },
  component: main,
  children: [
    {
      path: "home",
      meta: { title: "HomePage" },
      name: "home",
      component: () => import("../views/home/home.vue"),
    },
    {
      path: "ownspace_index",
      meta: { title: "UserProfile" },
      name: "ownspace_index",
      component: () => import("../views/setting/user/ownspace.vue"),
    },
  ],
};
export const appRouters: Array<Router> = [
  {
    path: "/setting",
    name: "setting",
    permission: "",
    meta: { title: "MemberManager" },
    icon: "&#xe606;",
    component: main,
    children: [
      {
        path: "user",
        permission: "Pages.Users",
        icon: "&#xe6b8;",
        meta: { title: "Users" },
        name: "user",
        component: () => import("../views/setting/user/user.vue"),
      },
      {
        path: "cashBackUser",
        permission: "Pages.Users.CashBackUser",
        icon: "&#xe6b8;",
        meta: { title: "储值通知" },
        name: "cashBackUser",
        component: () => import("../views/setting/user/cashBackUser.vue"),
      },
      {
        path: "adminList",
        permission: "Pages.Users.AdminList",
        icon: "&#xe6b8;",
        meta: { title: "管理员列表" },
        name: "adminList",
        component: () => import("../views/setting/user/adminList.vue"),
      },
      // {
      //     path: "create-supplier",
      //     permission: "Pages.Users",
      //     icon: "&#xe69a;",
      //     meta: { title: "CreateSupplier" },
      //     name: "createSupplier",
      //     component: () => import("../views/setting/user/create-supplier.vue")
      // },
      {
        path: "role",
        permission: "Pages.Roles",
        icon: "&#xe606;",
        meta: { title: "Roles" },
        name: "role",
        component: () => import("../views/setting/role/role.vue"),
      },
      {
        path: "tenant",
        permission: "Pages.Tenants",
        meta: { title: "Tenants" },
        name: "tenant",
        component: () => import("../views/setting/tenant/tenant.vue"),
      },
    ],
  },
  {
    path: "/notifice",
    name: "notifice",
    permission: "Pages.Notifice",
    meta: { title: "消息管理" },
    icon: "&#xe618;",
    component: main,
    children: [
      {
        path: "create-notifice",
        permission: "Pages.Notifice.CreateNotifice",
        icon: "&#xe62c;",
        meta: { title: "推送消息" },
        name: "create-notifice",
        component: () => import("../views/notifice/notifice.vue"),
      },
    ],
  },
  {
    path: "/court",
    name: "court",
    permission: "Pages.Court",
    meta: { title: "CourtManage" },
    icon: "&#xe719;",
    component: main,
    children: [
      {
        path: "court-list",
        permission: "Pages.Court",
        icon: "&#xe77e;",
        meta: { title: "CourtList" },
        name: "court-list",
        component: () => import("../views/court/court.vue"),
      },
      {
        path: "closure-list",
        permission: "Pages.Closure",
        icon: "&#xe77e;",
        meta: { title: "ClosureInfo" },
        name: "closure-list",
        component: () => import("../views/closure/closure.vue"),
      },
      {
        path: "preferential-list",
        permission: "Pages.Preferential",
        icon: "&#xe614;",
        meta: { title: "PreferentialCourt" },
        name: "preferential-list",
        component: () => import("../views/preferential/preferential.vue"),
      },
      {
        path: "courtInstallations",
        permission: "Pages.Court",
        icon: "&#xe77e;",
        meta: { title: "球场设施" },
        name: "courtInstallations",
        component: () => import("../views/court/courtInstallation.vue"),
      },
    ],
  },
  {
    path: "/price",
    name: "price",
    permission: "Pages.SupplierOffers",
    meta: { title: "PriceManage" },
    icon: "&#xe6fc;",
    component: main,
    children: [
      {
        path: "import-offer",
        permission: "Pages.SupplierOfferItems",
        icon: "&#xe67c;",
        meta: { title: "录入报价" },
        name: "importOffer",
        component: () => import("../views/supplierOffer/Import-offer.vue"),
      },
      {
        path: "supplierOffer-list",
        permission: "Pages.SupplierOffers",
        icon: "&#xe67c;",
        meta: { title: "供应商报价" },
        name: "upplierOffer-list",
        component: () =>
          import("../views/supplierOffer/supplierOffer-list.vue"),
      },
      {
        path: "offer-list",
        permission: "Pages.SupplierOfferItems",
        icon: "&#xe7f4;",
        meta: { title: "报价列表" },
        name: "offer-list",
        component: () => import("../views/supplierOffer/offer-list.vue"),
      },
      // {
      //     path: "my-offer",
      //     permission: "Pages.Offer.MyOffer",
      //     icon: "&#xe7f4;",
      //     meta: { title: "MyOffer" },
      //     name: "my-offer",
      //     component: () => import("../views/offer/my-offer.vue")
      // },
      // {
      //     path: "verify-offer",
      //     permission: "Pages.Offer.Verify",
      //     icon: "&#xe6a1;",
      //     meta: { title: "WaitVerifyOffer" },
      //     name: "verify-offer",
      //     component: () => import("../views/offer/verify-offer.vue")
      // },
    ],
  },
  {
    path: "/order",
    name: "order",
    permission: "Pages.Order",
    meta: { title: "OrderManage" },
    icon: "&#xe61d;",
    component: main,
    children: [
      {
        path: "order-list",
        permission: "Pages.Order",
        icon: "&#xe751;",
        meta: { title: "线上订单" },
        name: "order-list",
        component: () => import("../views/order/order.vue"),
      },
      {
        path: "offlineOrder-list",
        permission: "Pages.Order",
        icon: "&#xe751;",
        meta: { title: "线下订单" },
        name: "offlineOrder-list",
        component: () => import("../views/order/offlineOrder.vue"),
      },
    ],
  },
  {
    path: "/supplier",
    name: "supplier",
    permission: "Pages.Suppliers",
    meta: { title: "SupplierManage" },
    icon: "&#xe61d;",
    component: main,
    children: [
      {
        path: "supplier-list",
        permission: "Pages.Suppliers",
        icon: "&#xe751;",
        meta: { title: "SupplierList" },
        name: "supplier-list",
        component: () => import("../views/supplier/supplier.vue"),
      },
    ],
  },
  {
    path: "/groupBuy",
    component: main,
    name: "groupBuy",
    permission: "Pages.GroupBuy",
    icon: "&#xe614;",
    meta: { title: "团购列表" },
    children: [
      {
        path: "groupBuy-list",
        permission: "Pages.GroupBuy",
        icon: "&#xe77e;",
        meta: { title: "团购列表" },
        name: "groupBuy-list",
        component: () => import("../views/groupBuy/groupBuy.vue"),
      },
    ],
  },
  {
    path: "/constitute",
    name: "constitute",
    permission: "Pages.Constitute",
    meta: { title: "ConstituteManage" },
    icon: "&#xe639;",
    component: main,
    children: [
      {
        path: "constitute-list",
        permission: "Pages.Constitute",
        icon: "&#xe77e;",
        meta: { title: "ConstituteList" },
        name: "constitute-list",
        component: () => import("../views/constitute/constitute.vue"),
      },
    ],
  },
  {
    path: "/ticket",
    name: "ticket",
    permission: "Pages.Ticket",
    meta: { title: "套票会籍" },
    icon: "&#xe67d;",
    component: main,
    children: [
      {
        path: "ticket-list",
        permission: "Pages.Ticket",
        icon: "&#xe77e;",
        meta: { title: "套票列表" },
        name: "ticket-list",
        component: () => import("../views/ticket/ticket.vue"),
      },
      {
        path: "membership-list",
        permission: "Pages.Membership",
        icon: "&#xe77e;",
        meta: { title: "会籍列表" },
        name: "membership-list",
        component: () => import("../views/membership/membership.vue"),
      },
      {
        path: "membershipTrade",
        permission: "Pages.Membership",
        icon: "&#xe77e;",
        meta: { title: "会籍买卖记录" },
        name: "membershipTrade",
        component: () => import("../views/membership/membershipTrade.vue"),
      },
        {
        path: "membershipDemand",
        permission: "Pages.Membership",
        icon: "&#xe77e;",
        meta: { title: "会籍需求记录" },
        name: "membershipDemand",
        component: () => import("../views/membership/membershipDemand.vue"),
      },
    ],
  },
  {
    path: "/secondhand",
    name: "secondhand",
    permission: "Pages.SecondHand",
    meta: { title: "SecondHand" },
    icon: "&#xe718;",
    component: main,
    children: [
      {
        path: "secondhand-list",
        permission: "Pages.SecondHand",
        icon: "&#xe77e;",
        meta: { title: "SecondHand" },
        name: "secondhand-list",
        component: () => import("../views/secondHand/secondHand.vue"),
      },
      {
        path: "secondhandOrder",
        permission: "Pages.SecondHand",
        icon: "&#xe77e;",
        meta: { title: "二手物品订单" },
        name: "secondhandOrder",
        component: () => import("../views/secondHand/secondHandOrder.vue"),
      },
    ],
  },

  {
    path: "/content",
    name: "content",
    permission: "Pages.Topic",
    meta: { title: "ContentManage" },
    icon: "&#xe62b;",
    component: main,
    children: [
      {
        path: "topic",
        permission: "Pages.Topic",
        icon: "&#xeb6e;",
        meta: { title: "Topics" },
        name: "topic",
        component: () => import("../views/content/topic/topic.vue"),
      },
      {
        path: "article-category",
        permission: "Pages.ArticlesCategory",
        icon: "&#xe751;",
        meta: { title: "ArticlesCategories" },
        name: "category",
        component: () =>
          import("../views/content/articlecategory/category.vue"),
      },
      {
        path: "article",
        permission: "Pages.Articles",
        icon: "&#xe624;",
        meta: { title: "Articles" },
        name: "article",
        component: () => import("../views/content/article/article.vue"),
      },
      {
        path: "recruit",
        permission: "Pages.Recruits",
        icon: "&#xe68a;",
        meta: { title: "Recruits" },
        name: "recruit",
        component: () => import("../views/recruit/recruit.vue"),
      },
    ],
  },
  {
    path: "/couponManage",
    name: "couponManage",
    permission: "pages.Coupon",
    meta: { title: "优惠券管理" },
    icon: "&#xe62b;",
    component: main,
    children: [
      {
        path: "coupon",
        permission: "Pages.Coupon",
        icon: "&#xe6a8;",
        meta: { title: "优惠券发放记录" },
        name: "coupon",
        component: () => import("../views/coupon/coupon.vue"),
      },
      {
        path: "couponSetting",
        permission: "Pages.Coupon.Setting",
        icon: "&#xe6a8;",
        meta: { title: "优惠券设置" },
        name: "couponCourt",
        component: () => import("../views/coupon/couponSetting.vue"),
      },
      {
        path: "couponTransfer",
        permission: "Pages.Coupon.Share",
        icon: "&#xe6a8;",
        meta: { title: "优惠券分享记录" },
        name: "couponTransfer",
        component: () => import("../views/couponTransfer/couponTransfer.vue"),
      },
    ],
  },
  {
    path: "/card",
    name: "card",
    permission: "",
    meta: { title: "vip记录" },
    icon: "&#xe62b;",
    component: main,
    children: [
      {
        path: "buyCardRecord",
        permission: "Pages.BuyCardRecord",
        icon: "&#xe6a8;",
        meta: { title: "vip开通记录" },
        name: "buyCardRecord",
        component: () => import("../views/buyCardRecord/buyCardRecord.vue"),
      },
    ],
  },
   {
    path: "/merchant",
    name: "merchant",
    permission: "Pages.Merchant",
    meta: { title: "商户管理" },
    icon: "&#xe77e;",
    component: main,
    children: [
      {
        path: "merchant-list",
        permission: "Pages.Merchant",
        icon: "&#xe77e;",
        meta: { title: "商户列表" },
        name: "merchant-list",
        component: () => import("../views/merchant/merchant.vue"),
      },
    ],
  },
  {
    path: "/system",
    name: "system",
    permission: "",
    meta: { title: "SystemSettings" },
    icon: "&#xe6ae;",
    component: main,
    children: [
      {
        path: "create-sitemap",
        permission: "Pages.SiteConfig",
        icon: "&#xe68f",
        meta: { title: "上传sitemap" },
        name: "create-sitemap",
        component: () => import("../views/system/create-sitemap.vue"),
      },
      {
        path: "home-slider",
        permission: "Pages.HomeSlider",
        icon: "&#xe6a8;",
        meta: { title: "HomeSlider" },
        name: "home-slider",
        component: () => import("../views/system/home-slider.vue"),
      },
      {
        path: "holiday",
        permission: "Pages.Holiday",
        icon: "&#xe608;",
        meta: { title: "HolidayManager" },
        name: "holiday",
        component: () => import("../views/system/holiday.vue"),
      },
      {
        path: "region",
        permission: "Pages.Region",
        icon: "&#xe601;",
        meta: { title: "RegionManager" },
        name: "region",
        component: () => import("../views/system/region.vue"),
      },
      {
        path: "languages",
        permission: "Pages.Language",
        icon: "&#xe6ba;",
        meta: { title: "LanguageList" },
        name: "languages",
        component: () => import("../views/system/languages.vue"),
      },
      {
        path: "site-config",
        permission: "Pages.SiteConfig",
        icon: "&#xe68f;",
        meta: { title: "SiteConfig" },
        name: "site-config",
        component: () => import("../views/system/site-config.vue"),
      },
    ],
  },
];
export const routers = [
  loginRouter,
  registerRouter,
  // forgetRouter,
  locking,
  ...appRouters,
  otherRouters,
  // frontRouter
];
